import DriStatementGeneration from './DriStatementGeneration';

export default DriStatementGeneration;
